const features = [
  {
    icon: 'ri-shield-check-line',
    title: '正版授权',
    description: '所有漫画均获得正版授权，支持原创作者，阅读更安心',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    description: 'PC、平板、手机完美适配，随时随地畅享阅读',
    color: 'primary',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '采用先进图片压缩技术，保持高清同时加载飞速',
    color: 'secondary',
  },
  {
    icon: 'ri-bookmark-line',
    title: '智能书签',
    description: '自动记录阅读进度，多设备同步，追更不迷路',
    color: 'accent',
  },
  {
    icon: 'ri-translate',
    title: '丰富资源',
    description: '国漫、日漫、韩漫全覆盖，热门冷门一网打尽',
    color: 'primary',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心客服',
    description: '7×24小时在线客服，任何问题即时响应',
    color: 'secondary',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择琉璃漫站
          </h2>
          <p className="text-foreground-600 mt-3 text-base">
            用心做好每一个细节，只为给你最好的阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl bg-background-50 hover:bg-background-200/50 transition-all duration-300"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${
                feature.color === 'accent' ? 'bg-accent-100 text-accent-600' :
                feature.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-900 text-base mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}